import type { ChildMachineConfig } from "@hopper-b2b/checkout";
import { ActionTypes } from "./actions";
import { PaymentEvent } from "./events";

export const getUberPaymentMachine = (config: ChildMachineConfig) => ({
  on: {
    [PaymentEvent.SET_PAYMENT_DATA_AND_GO_NEXT]: {
      actions: ActionTypes.setPaymentData,
      target: config.nextState,
    },
    [PaymentEvent.PREVIOUS]: {
      target: config.previousState,
    },
    [PaymentEvent.NEXT]: {
      target: config.nextState,
    },
  },
});
